import React from "react";
import DualCalendar from "./DualCalendar";
import moment from "moment";
import Select from "react-select";

const TimeSlotDisplay = ({
  loading,
  timeZoneList,
  zone,
  selectedValue,
  hanldleTimezoneChange,
  selectedDate,
  handleDateClick,
  singleAvailableDate,
  error,
  isCalendarDisplay = true,
}) => {
  return (
    <div>
      {error ? null : (
        <div className="row mb-2 align-center">
          {isCalendarDisplay && (
            <p className="text-center w-100">
              <strong>Available Time</strong>
            </p>
          )}

          {/* Add timezone selector for other users */}
          {timeZoneList.length > 0 && zone && (
            <div className="w-100 m-3 mb-0">
              <p className="mb-0">
                <b>Time zone: </b>
              </p>
              <Select
                options={timeZoneList.map(({ _id, text }) => ({
                  value: _id?.$oid,
                  label: text || "",
                }))}
                styles={{
                  menu: (provided) => ({
                    ...provided,
                  }),
                  control: (provided) => ({
                    ...provided,
                    zIndex: 1,
                  }),
                  container: (provided) => ({
                    ...provided,
                    position: "relative",
                  }),
                }}
                className="base-line"
                value={
                  selectedValue
                    ? {
                        value: selectedValue._id.$oid,
                        label: selectedValue.text,
                      }
                    : {
                        value: "",
                        label: "",
                      }
                }
                onChange={hanldleTimezoneChange}
              />
            </div>
          )}
          {isCalendarDisplay && (
            <>
              <div className="w-100 mb-3 m-3">
                <DualCalendar
                  selectedDate={selectedDate}
                  handleDateClick={handleDateClick}
                />
              </div>

              <div className="d-flex align-items-center justify-content-between w-100 pad-lr-15">
                <div>
                  {/* Remove duplicate Available Time heading */}
                  <div className="available-time d-flex align-items-center justify-content-center flex-wrap gap-10">
                    {loading ? (
                      <p>Loading slots</p>
                    ) : !singleAvailableDate ? (
                      <p>No slots available</p>
                    ) : singleAvailableDate.length === 0 ? (
                      <p>No slots available</p>
                    ) : (
                      singleAvailableDate.map((time, index) => {
                        const { startTime, status } = time;

                        const currentTimeStamp = moment()
                          .tz(selectedValue.utc[0])
                          .format("YYYY-MM-DDTHH:mm:ss");
                        const targetTimeStamp = moment(startTime).toISOString();

                        const isValid = moment(
                          `${currentTimeStamp}.000Z`
                        ).isAfter(targetTimeStamp);

                        return (
                          <span
                            // className={
                            //   status === "booked" || isValid
                            //     ? "beforeDetails"
                            //     : zone !== "66291756f5181c284d0dbbf0"
                            //     ? "otherDetails"
                            //     : "timeDetails"
                            // }
                            className={
                              status === "booked" || isValid
                                ? "beforeDetails"
                                : "timeDetails"
                            }
                            key={index}
                            title={startTime}
                          >
                            {moment.utc(startTime).format("hh:mm A")}
                          </span>
                        );
                      })
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default TimeSlotDisplay;
